import { environment } from '../../../environments/environment';
import { HttpClient } from '@angular/common/http';
import {Injectable, Inject, PLATFORM_ID} from '@angular/core';
import { map } from 'rxjs/operators';
import {isPlatformBrowser} from "@angular/common";

@Injectable({
  providedIn: 'root'
})
export class DentistSettingsService {
  config;
    private localStorage: Storage = {
    getItem: () => "",
    setItem: () => null,
    removeItem: () => null,
    clear: () => null,
    length: 0,
    key: () => null,
  } satisfies Storage;
  constructor(@Inject(PLATFORM_ID) private platformId: Object, private http: HttpClient) {
    if (isPlatformBrowser(this.platformId)) {
      this.localStorage = window.localStorage;
    }
    this.config  = {
      headers: {
        "Content-Type": "application/json; charset=utf-8",
        "Access-Token": this.localStorage?.getItem('access_token')
      }
    };
  }

  getDentistProfileStep1(data) {
    return this.http.post(
      `${environment.apiURL}/service/dentistservice/dentist-step1`,
      data,
      this.config
    ).pipe(
      map(res =>{
        return res;
      })
    );
  }
  getDentistProfileStep2(data) {
    return this.http.post(
      `${environment.apiURL}/service/dentistservice/dentist-step2`,
      data,
      this.config
    ).pipe(
      map(res =>{
        return res;
      })
    );
  }
  getDentistProfileStep3(data) {
    return this.http.post(
      `${environment.apiURL}/service/dentistservice/dentist-step3`,
      data,
      this.config
    ).pipe(
      map(res =>{
        return res;
      })
    );
  }
  getDentistProfileStep4(data) {
    return this.http.post(
      `${environment.apiURL}/service/dentistservice/dentist-step4`,
      data,
      this.config
    ).pipe(
      map(res =>{
        return res;
      })
    );
  }
  getDentistProfileStep5(data) {
    return this.http.post(
      `${environment.apiURL}/service/dentistservice/dentist-step5`,
      data,
      this.config
    );
  }
  getDentistProfileStep6(data) {
    return this.http.post(
      `${environment.apiURL}/service/dentistservice/dentist-step6`,
      data,
      this.config
    );
  }
  getDentistProfileStep7(data) {
    return this.http.post(
      `${environment.apiURL}/service/dentistservice/dentist-step7`,
      data,
      this.config
    ).pipe(
      map(res =>{
        return res;
      })
    );
  }

}
